import React from 'react';
import { Divider, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { closeConfirmDialog } from 'src/_store/entities/confirmationDialog';
import { LoadingButton } from '@mui/lab';

export default function ConfirmDialog() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { open, title, content, onConfirm, onClose, confirmBtnTitle, isLoading, isSuccess, error } = useSelector((state) => state.entities.confirmationDialog)

    return (
        <Dialog
            open={open}
            onClose={(e) => e.preventDefault()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
        >
            {!!title
                &&
                <>
                    <DialogTitle id="alert-dialog-title">
                        {t(title)}
                    </DialogTitle>
                    <Divider />
                </>
            }
            <DialogContent>
                {t(content)}
            </DialogContent>
            <Divider />
            <DialogActions>
                {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                {!!error && <Typography color="error">{error}</Typography>}
                <Box mr="auto" />
                <LoadingButton
                    sx={{ textTransform: "none" }}
                    variant='contained'
                    onClick={() => {
                        if (typeof onClose === 'function') onClose();
                        dispatch(closeConfirmDialog());
                    }}
                    isLoading={isLoading}
                >
                    {t("Cancel")}
                </LoadingButton>
                {
                    !!onConfirm &&
                    <LoadingButton
                        sx={{ textTransform: "none", mx: '4px' }}
                        variant='contained'
                        onClick={() => {
                            onConfirm();
                            dispatch(closeConfirmDialog());
                        }}
                        autoFocus
                        isLoading={isLoading}
                        disabled={isLoading || isSuccess}
                    >
                        {confirmBtnTitle ?? t("Confirm")}
                    </LoadingButton>
                }
            </DialogActions>
        </Dialog>
    );
}
